export const volumeFormatter = (volume?: number): string => {
  return `${volume}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function areEquals(a?: number, b?: number): boolean {
  if (a === undefined && b === undefined) return true;
  if (a === undefined || b === undefined) return false;

  // Son igual si los primeros dos decimales coinciden
  return Number(a.toFixed(2)) === Number(b.toFixed(2));
}
